import React from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { CurrencyDisplay, ProTable, Link } from 'components/layout';
import { stringSorter } from 'utils';
import { useHasScopeTypeInProject } from 'hooks';
import useProjectFrozen from 'hooks/useProjectFrozen';

const url = ({ projectId, id }) =>
  `/projects/${projectId}/budget-virement/budgets/${id}`;

const BudgetsTable = ({ budgets }) => {
  const { projectId } = useParams();
  const projectFrozen = useProjectFrozen(projectId);

  const { hasScopeType } = useHasScopeTypeInProject('WRITE_BUDGET');
  const columns = [
    {
      title: 'Budget Category',
      dataIndex: ['budgetCategory', 'name'],
      sorter: (a, b) => a.budgetCategory.seq - b.budgetCategory.seq,
      render: (_, item) => (
        <Link to={url({ projectId, id: item.id })}>{_}</Link>
      ),
    },
    {
      title: 'Approved Funding',
      dataIndex: 'approvedFunding',
      sorter: (a, b) => a.approvedFunding - b.approvedFunding,
      render: (_, item) => (
        <Link to={url({ projectId, id: item.id })}>
          <CurrencyDisplay amount={item.approvedFunding} />
        </Link>
      ),
    },
    {
      title: 'Additional Funding',
      dataIndex: 'additionalFunding',
      sorter: (a, b) => a.additionalFunding - b.additionalFunding,
      render: (_, item) => (
        <Link to={url({ projectId, id: item.id })}>
          <CurrencyDisplay amount={item.additionalFunding} />
        </Link>
      ),
    },
    {
      title: 'Balance after Virement',
      dataIndex: 'balance',
      sorter: (a, b) => a.balance - b.balance,
      render: (_, item) => (
        <Link to={url({ projectId, id: item.id })}>
          <CurrencyDisplay amount={item.balance} />
        </Link>
      ),
    },
    {
      title: 'Remarks',
      dataIndex: 'remarks',
      sorter: (a, b) => stringSorter(a.remarks, b.remarks),
      ellipsis: true,
      render: (_, item) => (
        <Link to={url({ projectId, id: item.id })}>{_}</Link>
      ),
    },
    {
      title: 'Actions',
      hideInTable: !hasScopeType || projectFrozen,
      render: (_, item) => (
        <Link
          to={`/projects/${projectId}/budget-virement/budgets/${item.id}/edit`}
        >
          <Button type="primary">
            <EditOutlined /> Edit
          </Button>
        </Link>
      ),
    },
  ];

  return (
    <ProTable
      columns={columns}
      dataSource={budgets}
      pagination={false}
      search={false}
      toolBarRender={false}
      rowKey={({ id }) => id}
    />
  );
};

BudgetsTable.defaultProps = {
  budgets: [],
};

BudgetsTable.propTypes = {
  budgets: PropTypes.array.isRequired,
};

export default BudgetsTable;
